import { api } from '@api/api2';
import { GetPropertiesForRentPayload } from './types';

export const getPropertiesForRent = (payload: GetPropertiesForRentPayload) =>
  api.v4('get', 'area/long-term-rent/available-area-list', payload);
